import { component } from "picoapp";
import { reselectVariant } from "./product-selection";
import { store } from "@/vue/config/store";

export default component(async (node, ctx) => {
  const [{ default: KeenSlider }, { useUnveil, useFade }] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderElement = node.querySelector("[data-slider]");
  const imagesElement = node.querySelector("[data-images]");
  const productLink = node.querySelector("[data-link]");
  const slides = node.querySelectorAll("[data-product-card-slide]");
  const variantsIds = node.dataset.variantsIds.split("|");
  const options1 = node.dataset.variantsOption1.split("|");
  const options2 = node.dataset.variantsOption2.split("|");
  const options3 = node.dataset.variantsOption3.split("|");
  const variantsAvailable = node.dataset.variantsAvailable.split("|");
  const variantsTitle = node.dataset.variantsTitle.split("|");
  const variants = buildVariants(
    variantsIds,
    options1,
    options2,
    options3,
    variantsAvailable,
    variantsTitle
  );
  const selectId = node.dataset.selectId;
  const device = node.dataset.device;
  const productHandle = node.dataset.productHandle;
  let currentVariantId = node.dataset.preselectedId;
  let currentVariantColor = null;
  let productCardSlider = null;
  // const button = node.querySelector('[data-button]')

  const sliderOptions = {
    defaultAnimation: {
      duration: 300,
    },
    loop: true,
    drag: false,
    selector: slides,
    rubberband: false,
    slides: {
      perView: 1,
    },
    useFade: {
      duration: "0.2s",
      timingFunction: "ease-in-out",
    },
    useUnveil: {
      completed: false,
    },
    created: (instance) => {},
  };

  function buildSlider() {
    return KeenSlider(sliderElement, sliderOptions, [useUnveil, useFade]);
  }

  if (sliderElement) {
    productCardSlider = buildSlider();
  }

  function handleOptionClick(targetedNode) {
    const selectedOptions = Array.from(node.querySelectorAll("input:checked"));
    const variant = variants.find((variant) => {
      return selectedOptions.every((option) => {
        return variant[`option${option.dataset.position}`] === option.value;
      });
    });

    if (!variant) {
      const reselectedOption = reselectVariant(
        targetedNode.value,
        variants,
        selectId
      );
      handlePrice(node.dataset.productId, reselectedOption.dataset.vid);
    } else {
      const idx = productCardSlider.slides.findIndex(
        (slide) => slide.dataset.slideId === variant.id
      );
      currentVariantColor = variant.title;
      currentVariantId = variant.id;
      productCardSlider.moveToIdx(idx);
      productLink.href = productUrl();
      handlePrice(node.dataset.productId, variant.id);
    }
  }

  const handlePrice = (_productId, variantId) => {
    const variantPrice = store.getters["metafields/getVariantPrice"](
      parseInt(variantId)
    );
    const variantCompareAtPrice = store.getters[
      "metafields/getVariantCompareAtPrice"
    ](parseInt(variantId));

    window.dispatchEvent(
      new CustomEvent("price:update", {
        detail: {
          key: node.dataset.selectId,
          price: variantPrice,
          comparePrice: variantCompareAtPrice,
        },
      })
    );
  };

  function buildVariants(
    variantsIds,
    options1,
    options2,
    options3,
    availables,
    titles
  ) {
    const variants = [];
    variantsIds.forEach((id, index) => {
      variants.push({
        id,
        option1: options1[index],
        option2: options2[index],
        option3: options3[index],
        title: titles[index],
        options: [options1[index], options2[index], options3[index]].filter(
          (item) => item !== ""
        ),
        available: availables[index],
      });
    });
    return variants;
  }

  function productUrl() {
    const url = new URL(productLink.href);
    if (productCardSlider !== null) {
      url.searchParams.set("variant", currentVariantId);
    }
    return url.href;
  }

  imagesElement.addEventListener("click", () => {
    const destUrl = new URL(productUrl());
    window.maestro.fireTrackEvent("clickProduct", {
      "dest url": destUrl.href,
      "dest path": `${destUrl.pathname}${destUrl.search ?? ""}${
        destUrl.hash ?? ""
      }`,
      "from url": window.location.href,
      "from path": `${window.location.pathname}${window.location.search ?? ""}${
        window.location.hash ?? ""
      }`,
      data: imagesElement.currentSrc ?? imagesElement.src ?? "",
      target: "product",
      "page section":
        imagesElement.closest("[data-mtr-section]")?.dataset?.mtrSection ??
        null,
      position:
        imagesElement.closest("[data-mtr-position]")?.dataset?.mtrPosition ??
        null,
      "product name":
        imagesElement.closest("[data-mtr-product-name]")?.dataset
          ?.mtrProductName ?? null,
      "product color": currentVariantColor ?? null,
    });
    window.location.href = destUrl;
  });

  node.querySelectorAll('input[type="radio"]').forEach((radio) => {
    radio.addEventListener("click", () => {
      handleOptionClick(node);
    });
  });

  const selectedOptions = Array.from(node.querySelectorAll("input:checked"));
  selectedOptions.forEach((option) => option.click());

  if (productCardSlider) {
    ctx.on("product-card:update", (state) => {
      const sp = state.productCards;
      if (sp.device && sp.productHandle) {
        if (device === sp.device && productHandle === sp.productHandle) {
          console.log(
            `Reload after intersection, device: ${device} - product: ${productHandle}`
          );
          update();
        }
      }
    });

    ctx.on("product-card:updateAll", (state) => {
      const sp = state.productCards;
      if (sp.device) {
        if (device === sp.device) {
          update();
        }
      } else {
        update();
      }
    });

    function update() {
      productCardSlider.emit("unveilAll");
      productCardSlider.update(
        productCardSlider.options,
        productCardSlider.track.details.abs
      );
      productCardSlider.container.classList.remove("hide-init");
    }

    const intersectionObserverOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    const observer = new IntersectionObserver(
      handleItersection,
      intersectionObserverOptions
    );
    observer.observe(node);

    function handleItersection(entries, observer) {
      if (entries[0].isIntersecting) {
        const state = { productCards: { device, productHandle } };
        ctx.emit("product-card:update", state);
        observer.unobserve(entries[0].target);
        observer.disconnect();
      }
    }
  }
});
